<template>
    <div class="scroll-container">
        <div ref="scrollText" class="scroll-text">
            {{allBreakingNews}}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.scroll-container {
    display: flex;
    align-items: center;
    overflow: hidden;
    background-color: #B71717;
    height: 70%;
    -webkit-mask-image: linear-gradient(to right, #B71717 70%, transparent 100%);
    mask-image: linear-gradient(to right, #B71717 70%, transparent 100%);
}
.scroll-text {
    color: white;
    font-size: 15vh;
    display: inline-block;
    white-space: nowrap;
    /* animation properties */
    -moz-transform: translateX(calc(100vw - 82vh));
    -webkit-transform: translateX(calc(100vw - 82vh));
    transform: translateX(calc(100vw - 82vh));
    
    -moz-animation: scroll-left 15s linear infinite;
    -webkit-animation: scroll-left 15s linear infinite;
    animation: scroll-left 15s linear infinite;
}

/* for Firefox */
@-moz-keyframes scroll-left {
    from { -moz-transform: translateX(calc(100vw - 82vh)); }
    to { -moz-transform: translateX(-100%); }
}

/* for Chrome */
@-webkit-keyframes scroll-left {
    from { -webkit-transform: translateX(calc(100vw - 82vh)); }
    to { -webkit-transform: translateX(-100%); }
}

@keyframes scroll-left {
    from {
        -moz-transform: translateX(calc(100vw - 82vh));
        -webkit-transform: translateX(calc(100vw - 82vh));
        transform: translateX(calc(100vw - 82vh));
    }
    to {
        -moz-transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
    }
}
</style>
<script>
export default {
    props: {
        breaking: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        this.$watch('allBreakingNews', (newAllBreakingNews) => {
            this.$refs.scrollText.style.animationDuration = (newAllBreakingNews.length / 2) + 's';
        }, {immediate: true});
    },
    computed: {
        allBreakingNews() {
            return '+++ ' + this.breaking.map((news) => {return news.title}).join(' +++ ') + ' +++';
        }
    }
}
</script>
